import React, { useState } from 'react';
import './index.css';
import SearchFilter from '../../../components/Portfolio/SearchFilter';
// import unassignedTableData from '../../../constant/unassignedTable';
import Table from '../../../components/Common/Table';
import Pagination from '../../../components/Pagination';
import Button from '../../../components/Common/Button';
import { productType } from '../../../constant/selectOptions';
import { eligibleForLender } from '../../../constant/selectOptions';
import { productName } from '../../../constant/selectOptions';
import PortfolioContainer from '../../../components/Portfolio/PortfolioContainer';
import LenderUgroService from '../../../services/lender';
import { Context } from '../../../config/store';
import TableNoRecords from '../../../components/Common/Table/TableNoRecords';
import portfolio from '../../../constant/tableHeaders/portfolio';
import { downloadFile } from '../../../common/download';

function ApprovedPortfolio({ leadType, path }) {
	const [queryParams, setQueryParams] = React.useState('');
	const [tableData, setTableData] = useState({
		columns: portfolio,
		rows: [],
	});
	const [page, setCurrentPage] = useState(1);
	const [loading, setLoading] = React.useState(true);
	const [pagination, setPagination] = useState({});
	const { state, dispatch } = React.useContext(Context);
	const [sortParams, setSortParams] = React.useState({
		sortBy: '',
		sortOrder: '',
	});
	const showStatusFilter = () =>
		leadType.includes('disbursal') ? false : true;
	const getPortfolio = async (paramsChanged, sortBy, sortOrder) => {
		setLoading(true);
		const response = await LenderUgroService.getFilteredPortfolio({
			type: state.userType,
			leadType,
			page: paramsChanged ? 1 : page,
			dataExport: 0,
			sortBy: sortBy ? sortBy : sortParams.sortBy,
			sortOrder: sortOrder ? sortOrder : sortParams.sortOrder,

			queryParams,
		});
		const data = response.data.data?.cl_leads;
		setTableData({
			...tableData,
			rows: data?.data || [],
		});

		setCurrentPage(page);
		setPagination(response?.data?.data.cl_leads.pagination);
		setLoading(false);
	};
	const onSortChange = ({ sortOrder, sortBy }) => {
		setSortParams({ sortBy, sortOrder });
		getPortfolio(false, sortOrder, sortBy);
	};
	const exportLead = async () => {
		const response = await LenderUgroService.getFilteredPortfolio({
			type: state.userType,
			leadType,
			page,
			dataExport: 1,
			queryParams,
			sortBy: sortParams.sortBy,
			sortOrder: sortParams.sortOrder,
			responseType: 'blob',
		});
		downloadFile(response.data, leadType + +new Date());
	};

	React.useEffect(() => {
		getPortfolio();
	}, [page, path]);

	React.useEffect(() => {
		if (!loading) getPortfolio(true);
	}, [queryParams]);
	React.useEffect(() => {
		dispatch({
			type: 'selectedColender',
			selectedColender: path,
		});
		localStorage.setItem('selectedColender', path);
	}, [path]);

	return (
		<PortfolioContainer>
			<SearchFilter
				setQueryParams={setQueryParams}
				productTypes={productType}
				productNames={productName}
				lenders={eligibleForLender}
				statusOptions={
					showStatusFilter() && [
						{ label: 'Approved', value: '6,7' },
						{ label: 'Pull Back', value: 8 },
					]
				}
			></SearchFilter>
			<div className='d-flex justify-content-end'>
				<Button
					type='btn-export'
					classNames='float-right text-white mt-2 mb-2'
					clickHandler={exportLead}
				>
					<i class="fa fa-file-excel-o mr-1" aria-hidden="true"></i>
					Export Excel
				</Button>
			</div>
			<Table
				checkbox={false}
				columns={tableData.columns.filter(
					({ field }) => field !== 'lender_name'
				)}
				rows={tableData.rows}
				type='approved'
				onSortChange={onSortChange}
				loading={loading}
				reloadTable={getPortfolio}
			>
				{Boolean(!tableData.rows.length && !loading) && <TableNoRecords />}
			</Table>
			<div className="my-2">
				{pagination?.total_pages ? (
					<Pagination
						disabled={loading}
						setPage={setCurrentPage}
						total_pages={pagination.total_pages}
						total={pagination.total}
						showTotal={true}
					/>
				) : (
					''
				)}
			</div>
		</PortfolioContainer>
	);
}

export default ApprovedPortfolio;
